import $ from 'jquery';

export const helpShiftHandlers = () => {
    $(".help-shift-nav__form input").keyup(function (event) {
        if (event.keyCode === 13) {
            $(this).next('button').click();
        }
    });
};

